module.exports = __webpack_public_path__ + "img/34.e98a484e.jpg";